import React from 'react';
import {Navigate, Route, Routes, useParams} from 'react-router';
import {Title} from '../Title';
import {useCustomer} from '../../hooks/api/metadata';
import {IntentModelProvider} from './IntentModelProvider';
import {IntentModels} from './IntentModels';
import {IntentModel} from './IntentModel';

export const Intent = () => {
  return (
    <Routes>
      <Route path=":intentModelId/*" element={<_IntentModel />} />
      <Route index element={<IntentModels />} />
    </Routes>
  );
};

const _IntentModel = () => {
  const {intentModelId} = useParams();
  const {intentModels = []} = useCustomer();

  const intentModel = intentModels.find((model) =>
    model.id.equals(intentModelId ?? '')
  );
  if (!intentModel) {
    return <Navigate to="/intent" />;
  }

  return (
    <IntentModelProvider intentModel={intentModel}>
      <Title title={intentModel.label}>
        <Routes>
          <Route path="*" element={<IntentModel />} />
        </Routes>
      </Title>
    </IntentModelProvider>
  );
};
